<template>
  <div class="inventory-item-actions">
    <c-button
      :id="editButtonId"
      v-b-popover.hover.blur.top="'Редактировать'"
      class="inventory-item-actions__edit"
      size="iconic"
      icon="edit"
      @click="edit"
    />

    <c-button
      :id="`inventory-item-actions-${_uid}`"
      class="inventory-item-actions__menu"
      tabindex="-1"
      size="iconic"
      icon="menu"
    />

    <dropdown-menu :target="`inventory-item-actions-${_uid}`" :list="actionsList" @click="onActionClick" />
  </div>
</template>

<script>
import CButton from "@/components/controls2/Button";
import DropdownMenu from "@/components/dropdown-menu";

export default {
  components: { CButton, DropdownMenu },
  props: ["item", "canRemove"],

  data() {
    return {
      editButtonId: `inventory-item-edit-${this._uid}`,
    };
  },

  computed: {
    actionsList() {
      if (this.item.isWrittenOff) {
        return [
          { icon: "arrow-rotate-left", text: "Восстановить", action: "restore" },
          { icon: "clock-rotate-left", text: "История действий", action: "showHistory" },
          this.canRemove && { icon: "bin", iconColor: "secondary", text: "Удалить", action: "remove" },
        ].filter(Boolean);
      }

      return [
        { icon: "box-archive", text: "Списать", action: "writeOff" },
        this.item.isIssued
          ? { icon: "times", text: "Изъять у сотрудника", action: "withdraw" }
          : { icon: "check", text: "Выдать сотруднику", action: "issue" },
        { icon: "clock-rotate-left", text: "История действий", action: "showHistory" },
        this.canRemove && { icon: "bin", iconColor: "secondary", text: "Удалить", action: "remove" },
      ].filter(Boolean);
    },
  },

  methods: {
    edit() {
      this.$emit("edit", this.item);
      this.$root.$emit("bv::hide::popover", this.editButtonId);
    },
    onActionClick(action) {
      this.$emit(action.action, this.item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.inventory-item-actions {
  display: flex;

  &__edit {
    margin-right: 14px;
  }


}
</style>
<style>
.h-table th, .h-table td {
  max-width: 310px!important;
  overflow: hidden!important;
  text-overflow: ellipsis!important;
}


</style>